import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed z-10 inset-0 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "flex items-center justify-str min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_4 = {
  class: "inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-4 w-full max-w-screen-md",
  style: {"aspect-ratio":"1 / 1"}
}
const _hoisted_5 = { class: "bg-white p-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_details_image = _resolveComponent("details-image")!

  return ($props.modalVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal())),
            class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
            "aria-hidden": "true"
          }),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeModal())),
                class: "absolute top-2 right-2 cursor-pointer rounded-md bg-white p-2 z-10"
              }, _hoisted_7),
              _createVNode(_component_details_image, {
                "diamond-form": $props.diamondForm,
                "diamond-institute": $props.diamondInstitute,
                "diamond-certificate": $props.diamondCertificate,
                "diamond-image": $props.diamondImage,
                "show-viewer": "true"
              }, null, 8, ["diamond-form", "diamond-institute", "diamond-certificate", "diamond-image"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}